import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkLoader } from 'uitk-react-loader';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { PlayerStates } from './types.esm.js';

var UitkVideoLayerLoading = function (_a) {
    var className = _a.className, playerState = _a.playerState;
    var formatText = useLocalization().formatText;
    return (React.createElement(React.Fragment, null,
        playerState === PlayerStates.get('unstarted') ? React.createElement(UitkScrim, { type: UitkScrimType.OVERLAY }) : null,
        React.createElement(UitkLayoutPosition, { className: className, type: "absolute", position: { top: 'center', left: 'center' } },
            React.createElement(UitkLoader, { isDarkBackground: true, title: formatText('video.loading.title') }))));
};

export { UitkVideoLayerLoading };
